<!--MODO ASISTENTE-->
<div id="asistente-pie" *ngIf="modo=='asistente'" class="css-Pie-1 pie" [ngClass]="{'pie-minimizado':minimizado}">
    <ng-container *ngIf="!minimizado && !ctx.hideAllButtonsForm">
        <div class="css-Icono_Minimizar icono_minimizar" (click)="boton_click()">
        </div>
    </ng-container>
    <ng-container *ngIf="minimizado">
        <div class="css-Icono_Minimizar icono_minimizar" (click)="boton_click()">
            <img src="assets/images/launch.svg" class="css-Vector-1 vector_maximizar">
        </div>
    </ng-container>

</div>

<!--MODO CHAT-->
<div id="asistente-pie" *ngIf="modo=='chat'" class="css-Pie-1 pie" >
    <ng-container *ngIf="!minimizado && !ctx.hideAllButtonsForm">
        <div class="css-Icono_Minimizar icono_minimizar" (click)="boton_click()">
        </div>
    </ng-container>
    <ng-container *ngIf="minimizado">
        <div class="css-Icono_Minimizar icono_minimizar" (click)="boton_click()">
            <img src="assets/images/launch.svg" class="css-Vector-1 vector_maximizar">
        </div>
    </ng-container>
    <!--
    <div class="css-Icono_Minimizar icono_minimizar icono_minimizar-diff1" *ngIf="!minimizado && !ctx.hideAllButtonsForm">
        <img src="assets/images/basecomponents-images/vectors58635931.svg" width="19.833px" height="19.833px"
            class="css-Vector-2 vector vector-diff1">
        <img src="assets/images/basecomponents-images/vectors58635932.svg" width="13.807px" height="13.807px"
            class="css-Vector-3 vector_1 vector_1-diff1">
    </div>
    -->
</div>